import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Info } from 'lucide-react';
import { ProblemEditorForm } from '@/features/AdminProblems/ProblemEditorForm';

export const Route = createFileRoute('/trainer/problems/$problemId')({
  component: TrainerProblemEditorPage,
});

function TrainerProblemEditorPage() {
  const { problemId } = Route.useParams();
  const navigate = useNavigate();
  return (
    <ProblemEditorForm
      problemId={problemId}
      onBack={() => navigate({ to: '/trainer/problems' })}
      draftNotice={
        // Student reads go through the public catalogue, which only carries
        // published problems. A draft can be linked to a topic but will not
        // open, so say so here rather than let a trainer find out from a
        // student.
        <div className="flex items-start gap-2 px-5 py-2.5 border-b bg-amber-50 text-[13px] text-amber-900">
          <Info className="h-4 w-4 mt-0.5 shrink-0" />
          <span>
            This problem is a draft. You can add it to a topic now, but students
            won't be able to open it until you publish it.
          </span>
        </div>
      }
    />
  );
}
